import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router';

import SmoothScroll from './extra/SmoothScroll';
import Error404 from './extra/Error404';
import LoadingScreen from './extra/LoadingScreen';
import QuoteReviewBuyerScreen from '../js/screens/Buyer/QuoteReviewBuyerScreen';
import HomePage from '../js/pages/HomePage';
import BuyerDashboard from '../js/pages/Buyer/BuyerDashboard';
import GetQuotePage from '../js/pages/GetQuotePage';
import AboutUsPage from '@/js/pages/AboutUsPage';
import MakersharksReviewPage from '../js/pages/Makersharks/MakersharksReviewPage';
import AssistantPage from '../js/pages/AssistantPage';
import BuyerNavbar from '@/js/components/Navbar/BuyerNavbar';
import ProtectedRoute from './extra/ProtectedRoute';
import BuyerEditProfilePage from '@/js/pages/Buyer/BuyerEditProfilePage';
import SearchPage from '@/js/pages/Buyer/SearchPage';
import BuyerCreateProject from '@/js/pages/Buyer/BuyerCreateProject';
import BuyerAddParts from '@/js/pages/Buyer/BuyerAddParts';
import BuyerPartsDashboard from '@/js/pages/Buyer/BuyerPartsDashboard';
import ManufacturerBookmarked from '@/js/pages/Buyer/ManufacturerBookmarked';
import BuyerManufacturerProfile from '@/js/pages/Buyer/BuyerManufacturerProfile';
import RFQFormPage from '@/js/pages/Buyer/RFQFormPage';
import ProjectDetailsPage from '@/js/pages/Buyer/ProjectDetailsPage';
import ThreeDViewer from '@/js/components/3DViewer/ThreeDViewer';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const BuyerLayout = () => {
  const [isNavHidden, setIsNavHidden] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 700);
  }, []);

  return (
    <div className="flex flex-col justify-between">
      {isLoading ? (
        <LoadingScreen />
      ) : (
        <>
          <div className={classNames('navBar', isNavHidden && 'hidden')}>
            <BuyerNavbar />
          </div>
          <SmoothScroll>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="about" element={<AboutUsPage />} />
              <Route
                path="manufacturer/:manufacturerId"
                element={<BuyerManufacturerProfile />}
              />

              <Route
                path="buyer/*"
                element={
                  <ProtectedRoute allowedRole="buyer">
                    <Routes>
                      <Route path="dashboard" element={<BuyerDashboard />} />
                      <Route
                        path="edit-profile"
                        element={<BuyerEditProfilePage />}
                      />

                      <Route
                        path="*"
                        element={<Navigate to="/404" replace />}
                      />
                    </Routes>
                  </ProtectedRoute>
                }
              />

              <Route path="test" element={<ThreeDViewer />} />

              <Route
                path="search/*"
                element={
                  <ProtectedRoute allowedRole="buyer">
                    <Routes>
                      <Route path="" element={<SearchPage />} />
                      <Route
                        path="/:projectName/:projectId"
                        element={<SearchPage />}
                      />
                    </Routes>
                  </ProtectedRoute>
                }
              />

              <Route
                path="project/*"
                element={
                  <ProtectedRoute allowedRole="buyer">
                    <Routes>
                      <Route
                        path="details/:projectName/:projectId"
                        element={<ProjectDetailsPage />}
                      />
                      <Route path="details" element={<ProjectDetailsPage />} />
                      <Route
                        path="add-parts/:projectName/:projectId"
                        element={<BuyerAddParts />}
                      />
                      <Route
                        path="parts/:projectName/:projectId"
                        element={<BuyerPartsDashboard />}
                      />
                      <Route
                        path="bookmarked/:projectName/:projectId"
                        element={<ManufacturerBookmarked />}
                      />

                      <Route
                        path="createRFQ/:projectName/:projectId"
                        element={<RFQFormPage />}
                      />
                    </Routes>
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Navigate to="/404" replace />} />
            </Routes>
          </SmoothScroll>
        </>
      )}
    </div>
  );
};

export default BuyerLayout;
